
import React, { Component } from 'react';

import Method from './Method';
import Pod from './Pod';
import VisibilityToggle from './VisibilityToggle'

class Type extends Component {
  constructor(props) {
    super(props);
    this.state = {visible: true};
  }

  setVisibilitiy = (visible) => this.setState({visible: visible});


  render() {
    return (
      <div>
        <h1>{this.props.kind[0].toUpperCase() + this.props.kind.substr(1)} {this.props.name} - {this.props.summary}</h1>
        
        <VisibilityToggle visible={this.state.visible} onChange={this.setVisibilitiy}/>
        {!this.state.visible && ' Expand Description'}
        {this.state.visible && <Pod contents={this.props.desc}/>}
        {this.props.methods.length && <h2>Methods</h2>}
        {this.props.methods.map((method, idx) => <Method key={idx} name={method.name} desc={method.desc} sig={method.sig}/>)}
      </div>
    )
  }
}


export default Type;



// WEBPACK FOOTER //
// ./src/Type.js